export default "__VITE_ASSET__gwfWz$rX__"